import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GetAllService {
  private http = inject(HttpClient);

  public async getAll<T>(url: string, limit = 50, page = 0, results: T[] = []): Promise<T[]> {
    const separator = url.includes('?') ? '&' : '?';
    const fullUrl = `${url}${separator}limit=${limit}&page=${page}`;
    const { data } = await lastValueFrom(this.http.get<{ data: T[] }>(fullUrl));
    results = [...results, ...data];
    if (data.length < limit) return results;
    return this.getAll(url, limit, page + 1, results);
  }
}
